import { isFallbackImage } from '@/utils/content'

export function useCoverPosition(coverUrl: string) {
  return isFallbackImage(coverUrl) ? 'object-center' : 'object-top'
}
